export default __webpack_public_path__ + "static/media/sign.248b3eb1.png";